import { render } from "./Option.vue?vue&type=template&id=1230796a&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"

import "./Option.vue?vue&type=style&index=0&id=1230796a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1230796a"]])

export default __exports__